/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Metadata_TitleInputs */

const en_common_metadata_title = /** @type {(inputs: Common_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel Lobby AI Video Generator — Make the Duet Trend from 2 Photos`)
};

const zh_common_metadata_title = /** @type {(inputs: Common_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel Lobby AI Filter｜规划双人对唱视频`)
};

/**
* | output |
* | --- |
* | "Hotel Lobby AI Video Generator — Make the Duet Trend from 2 Photos" |
*
* @param {Common_Metadata_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_metadata_title = /** @type {((inputs?: Common_Metadata_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Metadata_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_metadata_title(inputs)
	return zh_common_metadata_title(inputs)
});
export { common_metadata_title as "common.metadata.title" }